export default "__VITE_ASSET__C7Rq04pR__"